import React, {useState} from 'react';
import _ from 'lodash';

import {Form, Button, Modal} from '@components';
import constants from '@constants';
import resources from '@resources';
import * as hooks from './hooks';
import {Props} from './types';
import utils from '@utils';
import paths from '@paths';

import './index.scss';

const Detail: React.FC<Props> = props => {
  const id = utils.pathParams.getUserId(props.location.pathname);
  const [isModal, setIsModal] = useState(false);

  hooks.useMount({...props}, props.actions, setIsModal);

  const initialValues = {
    firstName: props.users.detail.firstName,
    lastName: props.users.detail.lastName,
    lastKana: props.users.detail.lastKana,
    firstKana: props.users.detail.firstKana,
    prefecture: props.users.detail.prefecture,
    authLevel: props.users.detail.authLevel,
    teamId: props.me.teamId,
    email: props.users.detail.email || '-',
    phoneNumber: props.users.detail.phoneNumber || '-',
    position: props.users.detail.position || '-',
    organization: props.users.detail.organization || '-',
    gender:
      _.isNull(props.users.detail.gender) ||
      props.users.detail.gender === constants.USERS.NOT_SELECTED_GENDER
        ? ''
        : props.users.detail.gender,
    birthyear: resources.users.getBirthValue(
      'year',
      props.users.detail.birthdate
    ),
    birthmonth: resources.users.getBirthValue(
      'month',
      props.users.detail.birthdate
    ),
    birthday: resources.users.getBirthValue(
      'day',
      props.users.detail.birthdate
    ),
  };

  return (
    <div className="a__user-detail">
      <div className="b__title">
        <Button.GoBack history={props.history} />
        ユーザー詳細
      </div>
      <div className="b__main">
        <div className="w__create-field">
          <div className="w__information-field">
            <Form.User
              initialValues={initialValues}
              handleSubmit={() => {}}
              me={props.me}
              submitText=""
              users={props.users}
              detail
              disabled
            />
          </div>
        </div>
        <div className="w__side-buttons">
          <Button.Normal
            text="ユーザーを編集する"
            color="yellow"
            className="b__edit"
            disabled={resources.users.getDisabled(props.me, props.users.detail)}
            onClick={() => {
              props.history.push(`${paths.users.edit}/${id}`);
            }}
          />
        </div>
      </div>
      <Modal.Normal
        hideCloseIcon={true}
        hiddenCancelButton={true}
        isAutoClose={false}
        isModal={isModal}
        handleCloseModal={setIsModal}
        size="xs"
        title="ユーザーが存在しません"
        cancelText="前のページに戻る"
        message={
          <>
            存在しないユーザーもしくは、既に削除されているユーザーです。
            <br />
            ボタンをクリックして、前のページに戻ってください。
          </>
        }
      >
        <Button.Normal
          text="前のページに戻る"
          onClick={() => props.history.goBack()}
          color="yellow"
          className="b__go-back"
        />
      </Modal.Normal>
    </div>
  );
};

export default Detail;
